import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LANGUAGE_ROUTE_PAIRS } from '../../constants';

// Reuses the site's existing route-pair table (LANGUAGE_ROUTE_PAIRS in
// constants.ts, the same lookup the global footer uses for imprint/privacy/gtc)
// instead of hardcoding each guide's counterpart URL twice. Carries the
// current query string (gclid, utm_*, ...) across the switch, matching how
// the site's existing language switcher behaves elsewhere.
interface GuideLanguageSwitchProps {
  from: string;
  targetLang: 'EN' | 'DE';
  label: string;
}

export const GuideLanguageSwitch: React.FC<GuideLanguageSwitchProps> = ({ from, targetLang, label }) => {
  const { search } = useLocation();
  const pair = LANGUAGE_ROUTE_PAIRS[from];
  if (!pair) return null;
  return (
    <Link
      to={{ pathname: pair[targetLang], search }}
      className="inline-flex items-center gap-1.5 text-sm font-semibold text-pstax-link hover:underline underline-offset-2"
    >
      {label}
    </Link>
  );
};
